module.exports = __webpack_public_path__ + "img/synaplus_logo_square256.18dad9e7.svg";